import * as types from '../constants/ActionTypes';

export const initialState = {
    downloadFiles: false,
    exportStarted: false,
    files: [],
    filesHR: [],
    highReadability: false,
    homeworkFileList: [],
    inputError: false,
    loaded: true,
    message: '',
    rowNumber: 1
};

export default function HomeworkExportReducer(state = initialState, action = {}) {
    switch (action.type) {
        case types.START_HOMEWORK_EXPORT:
            return {
                ...state,
                exportStarted: true,
                homeworkFileList: [
                    { homeworkTitle: action.homeworkTitle, homeworkFileDescription: '.docx' },
                    { homeworkTitle: `Soluzioni - ${action.homeworkTitle}`, homeworkFileDescription: '.docx' }
                ]
            };
        case types.STOP_HOMEWORK_EXPORT:
            return {
                ...state,
                exportStarted: false,
                homeworkFileList: [],
                rowNumber: 1,
                downloadFiles: false,
                files: [],
                filesHR: [],
                message: ''
            };
        case types.CHANGE_ROW_NUMBER:
            return {
                ...state,
                homeworkFileList: action.filesName,
                rowNumber: action.rowNumber,
                downloadFiles: false,
                message: ''
            };
        case types.HIGH_READABILITY_FLAG:
            return {
                ...state,
                highReadability: !state.highReadability,
                downloadFiles: false,
                message: ''
            };
        case types.CALL_T2P_SUCCESS:
            return {
                ...state,
                downloadFiles: true,
                loaded: true,
                message: '',
                fileType: action.fileType,
                homeworkFileList: action.filesName.map(homework => ({
                    homeworkTitle: homework.fileName,
                    homeworkUrl: homework.link,
                    homeworkIsBes: homework.isBes,
                    homeworkIsZip: homework.isZip || false
                }))
            };
        case types.CALL_T2P_FAILURE:
            return {
                ...state,
                message: 'Questa azione al momento non è disponibile, riprova più tardi. Ci scusiamo per il disagio.',
                loaded: true
            };
        case types.CHECK_FILE_EXISTENCE_SUCCESS:
            return {
                ...state,
                message: ''
            };
        case types.CHECK_FILE_EXISTENCE_FAILURE:
            return {
                ...state,
                message: 'Questa azione al momento non è disponibile, riprova più tardi. Ci scusiamo per il disagio.'
            };
        case types.CHECK_FILE_EXISTENCE:
            return {
                ...state,
                message: ''
            };
        case types.CALL_T2P:
            return {
                ...state,
                loaded: false,
                message: ''
            };
        case types.RESET_FILES_WORD:
            return {
                ...state,
                files: [],
                message: ''
            };
        case types.DOWNLOAD_FILES_WORD:
            return {
                ...state,
                downloadFiles: true
            };
        case types.CHANGE_INPUT_STYLE:
            return {
                ...state,
                inputError: true
            };
        default:
            return state;
    }
}
